import { all, call, delay, spawn } from "redux-saga/effects";
import * as Sentry from "@sentry/react";
import testSagas from "@store/tests/testSagas";
import analyticsSagas from "@store/analytics/analyticsSagas";
import uiSagas from "@store/ui/uiSagas";
import userSagas from "@utils/redux-utils/sagas/userSaga";
import { watchTestListSaga } from "@store/testList/testListSaga";
import { watchTestSessionListSaga } from "@store/testSessionList/testSessionListSaga";
import connectionSagas from "@store/connection/connectionSagas";
import productSagas from "./product/productSagas";
import testSuiteSaga from "@store/testSuite/testSuiteSaga";
import trackingSagas from "@store/tracking/trackingSagas";
import licenceSagas from "@store/licence/licenceSagas";
import adminConfigurationsSagas from "@store/adminConfigurations/adminConfigurationsSagas";

export function* superviseRootSaga(saga: () => Generator, name: string) {
  while (true) {
    try {
      yield call(saga);
      return;
    } catch (error) {
      console.error(`Root saga "${name}" crashed; restarting`, error);
      Sentry.captureException(error, {
        tags: { area: "root-saga", saga: name },
      });
      yield delay(1000);
    }
  }
}

export default function* rootSaga() {
  yield all(
    [
      { name: "testSagas", saga: testSagas },
      { name: "analyticsSagas", saga: analyticsSagas },
      { name: "uiSagas", saga: uiSagas },
      { name: "userSagas", saga: userSagas },
      { name: "watchTestListSaga", saga: watchTestListSaga },
      { name: "watchTestSessionListSaga", saga: watchTestSessionListSaga },
      { name: "connectionSagas", saga: connectionSagas },
      { name: "productSagas", saga: productSagas },
      { name: "testSuiteSaga", saga: testSuiteSaga },
      { name: "trackingSagas", saga: trackingSagas },
      { name: "licenceSagas", saga: licenceSagas },
      { name: "adminConfigurationsSagas", saga: adminConfigurationsSagas },
    ].map(({ name, saga }) => spawn(superviseRootSaga, saga, name)),
  );
}
